import { OpenInNewRounded } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { Link } from 'react-router';

import { taskCardContent } from './ThemaTaskCard.content';

type ThemaTaskCardHeadingProps = {
  readonly uri: string;
};

export const ThemaTaskCardHeading = (props: ThemaTaskCardHeadingProps) => (
  <Stack direction="row" alignItems="center" spacing={1}>
    <Typography fontWeight="500">{taskCardContent.heading}</Typography>
    <Link target="_blank" rel="noopener" to={props.uri} onClick={(e) => e.stopPropagation()}>
      <Box display="flex" alignItems="center" gap={0.5} ml={1}>
        <Typography fontWeight="500" color="textBrand">
          {taskCardContent.jira}
        </Typography>
        <OpenInNewRounded sx={{ fontSize: '18px', ':hover': { color: (theme) => theme.palette.primary.main } }} />
      </Box>
    </Link>
  </Stack>
);
